import React, { useState } from 'react';
import { DatePicker, Form, message, Space } from 'antd';
import InfoModal from './infoModal';
import moment from 'moment';
import { TaskType } from 'types';

interface Props {
	visible: boolean;
	orderId: number;
	onCancel: () => void;
	onOk: (date: moment.Moment) => Promise<void>;
	type: TaskType;
}

export const TaskCreationModal: React.FC<Props> = ({ visible, onCancel, type, onOk }) => {
	const [date, setDate] = useState<moment.Moment | undefined>();
	const [time, setTime] = useState<moment.Moment | undefined>();
	const [loading, setLoading] = useState(false);

	const handleSubmit = async () => {
		if (!date) {
			message.error('Nie wybrano daty');
			return;
		}

		const taskDate = date.clone();
		if (time) {
			taskDate.hours(time.hours()).minutes(time.minutes()).seconds(0).milliseconds(0);
		} else {
			taskDate.hours(0).minutes(0).seconds(0).milliseconds(0);
		}

		try {
			setLoading(true);
			await onOk(taskDate);

			setDate(undefined);
			setTime(undefined);
		} catch (error) {
			console.error(error);
			message.error(`Nie udało się utworzyć zadania: ${error}`);
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		setDate(undefined);
		setTime(undefined);
		onCancel();
	};

	const title = type === TaskType.delivery ? 'Utwórz zadanie dostarczenia' : 'Utwórz zadanie odebrania';

	return (
		<InfoModal
			visible={visible}
			closable={false}
			cancelText="Anuluj"
			okText="Utwórz"
			onCancel={handleCancel}
			onOk={handleSubmit}
			disabled={!date}
			loading={loading}
		>
			<h1>{title}</h1>
			<Form layout="vertical">
				<Form.Item label="Data zadania" required>
					<Space size={20}>
						<DatePicker
							size="large"
							placeholder="Wybierz datę"
							value={date ?? null}
							onChange={(m) => m && setDate(m)}
							format="YYYY-MM-DD"
						/>
						<DatePicker.TimePicker
							size="large"
							format="HH:mm"
							placeholder="Wybierz godzinę"
							value={time ?? null}
							onChange={(m) => setTime(m ?? undefined)}
						/>
					</Space>
				</Form.Item>
			</Form>
		</InfoModal>
	);
};
